import { useEffect } from "react"

/**
 * Closes a component when the escape key is pressed.
 *
 * @param isOpen Boolean indicating if the component is open.
 * @param onClose Setter function to close the component.
 */

export const useCloseOnEscape = (isOpen: boolean, onClose: (value: boolean) => void) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape" || event.key === "Backspace") {
                onClose(false)
            }
        }

        if (isOpen) {
            document.addEventListener("keydown", handleKeyDown)
        }

        return () => {
            document.removeEventListener("keydown", handleKeyDown)
        }
    }, [isOpen, onClose])
}
